"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetContractService = class FieldsetContractService extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    readonly;
    onReadonly(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("readonly");
    }
    billingCategories;
    async $$load_billingCategories() {
        return this.$fn.fetch('get_tags', { parameters: { tag_type: 'billing_category' } });
    }
    services;
    async $$load_services() {
        return this.$fn.fetch('suggest_product', {
            parameters: { query: '*', top: 50, skip: 0, product_types: 'service', product_invoice_groups: 'all' }
        }).then(data => _.orderBy(data, [p => p.name.toLowerCase()]));
    }
    invoiceGroups;
    async $$load_invoiceGroups() {
        return this.$fn.fetch('list_product_invoice_group');
    }
    ux;
    b_3943151158818434_multiple;
    dataMembers = ['billingCategories', 'services', 'invoiceGroups', 'ux', 'b_3943151158818434_multiple'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                billingCategories: null,
                services: null,
                invoiceGroups: null,
                ux: null,
                b_3943151158818434_multiple: false,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_setData_8868_getActionArgs($event) {
        return {
            path: "item.name",
            value: $event.data.option.name,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_6466705138206980_setData_8870_getActionArgs($event) {
        return {
            path: "item.service_id",
            value: $event.data.option.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_6466705138206980_setData_8872_getActionArgs($event) {
        return {
            path: "feeItem.unit",
            value: $event.data.option.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_6466705138206980_optionSelected(event, scope) {
        return await this.actions.evh_6466705138206980_optionSelected.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8866 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8865 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8866,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8865],
        });
        const act_6466705138206980_setData_8868 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_8868_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_optionSelected_8867 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_8868,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_6466705138206980_setData_8870 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_8870_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_optionSelected_8869 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_8870,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_6466705138206980_setData_8872 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_8872_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_optionSelected_8871 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_8872,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_6466705138206980_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_optionSelected_8867, evh_6466705138206980_optionSelected_8869, evh_6466705138206980_optionSelected_8871],
        });
        return {
            act_7315092382398562_reloadComponentData_8866,
            evh_7315092382398562_reload_8865,
            evh_7315092382398562_reload,
            act_6466705138206980_setData_8868,
            evh_6466705138206980_optionSelected_8867,
            act_6466705138206980_setData_8870,
            evh_6466705138206980_optionSelected_8869,
            act_6466705138206980_setData_8872,
            evh_6466705138206980_optionSelected_8871,
            evh_6466705138206980_optionSelected,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetContractService.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetContractService.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetContractService.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetContractService.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], FieldsetContractService.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetContractService.prototype, "onReadonly", null);
FieldsetContractService = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetContractService);
exports.default = FieldsetContractService;
vue_property_decorator_1.Vue.component("FieldsetContractService", FieldsetContractService);
